import template from './add-realization.html';

class AddRealizationComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    RealizationService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.RealizationService = RealizationService;

    this.realization = {};
    this.date = new Date();
  }

  add(form) {
    if (form.$invalid) {
      return false;
    }

    this.realization.date = this.moment(this.date).format('YYYY-MM-DD');
    this.realization.startTime = this.startTime;
    this.realization.endTime = this.endTime;
    this.RealizationService.add(
      {
        data: this.realization,
        addToLocal: true
      }
    ).then(() => {
      this.$state.go('modules.realizations.byEmployee');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Dodano realizację')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const AddRealization = {
  template,
  controller: AddRealizationComponent
};
